import React, { memo, useMemo } from 'react';

import { CompanyInfo, SocietyInfo } from 'components/opportunity-page';
import { useOpportunity } from 'lib/providers/OpportunityProvider';
import { parseArrayResponse, parseResponse } from 'lib/utils/parser';
import { CompanyResponse } from 'lib/models/company';
import { StudentSocietyResponse } from 'lib/models/student-society';

import styles from './CreatedByInfo.module.scss';

type CreatedByInfoProps = {
  className?: string;
};

export const CreatedByInfo: React.FC<CreatedByInfoProps> = memo(({ className = '' }: CreatedByInfoProps) => {
  const { opportunity } = useOpportunity();
  const { creatable_for, cohost_applications: cohostApplicationsResponse, touchpointable_type } = opportunity;

  const cohostSocieties = useMemo(() => {
    const cohostApplications = parseArrayResponse(cohostApplicationsResponse);
    return cohostApplications.map((cohostApplication) => parseResponse(cohostApplication.cohost));
  }, [cohostApplicationsResponse]);

  if (creatable_for.data.type === 'company') {
    const createdBy = parseResponse(creatable_for as CompanyResponse);
    return (
      <div className={styles.list}>
        <CompanyInfo className={className} company={createdBy} opportunityType={touchpointable_type} showFullContent={cohostSocieties.length === 0} />
        {cohostSocieties.map((cohostSociety) => (
          <SocietyInfo key={cohostSociety.id} className={className} society={cohostSociety} showFullContent={false} />
        ))}
      </div>
    );
  } else if (creatable_for.data.type === 'student_society') {
    const createdBy = parseResponse(creatable_for as StudentSocietyResponse);
    return (
      <div className={styles.list}>
        <SocietyInfo className={className} society={createdBy} showFullContent={cohostSocieties.length === 0} />
        {cohostSocieties.map((cohostSociety) => (
          <SocietyInfo key={cohostSociety.id} className={className} society={cohostSociety} showFullContent={false} />
        ))}
      </div>
    );
  } else {
    return null;
  }
});

CreatedByInfo.displayName = 'CreatedByInfo';
